import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAlert,{style:({
      'background-color': _vm.color,
      color: 'white',
    })},[_c('h5',{style:({
        color: _vm.getSecondaryColor,
        textAlign: 'center',
      })},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }